webpackJsonpPois([2],{

/***/ 2005:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2006);

__webpack_require__(359);

var _client = __webpack_require__(360);

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _client2.default)(window.__initialState);

/***/ }),

/***/ 2006:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[2005]);


// WEBPACK FOOTER //
// list.b69723994752b6931457.js